var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87316 11.9896C8.88819 12.0089 8.9074 12.0244 8.92933 12.0351C8.95126 12.0458 8.97533 12.0513 8.99972 12.0513C9.02411 12.0513 9.04819 12.0458 9.07011 12.0351C9.09204 12.0244 9.11125 12.0089 9.12628 11.9896L11.3763 9.14299C11.4586 9.03853 11.3843 8.88384 11.2497 8.88384H9.76111V2.08563C9.76111 1.99723 9.68878 1.92491 9.60039 1.92491H8.39503C8.30664 1.92491 8.23432 1.99723 8.23432 2.08563V8.88183H6.74972C6.61512 8.88183 6.54079 9.03652 6.62316 9.14098L8.87316 11.9896ZM16.3524 11.2865H15.147C15.0587 11.2865 14.9863 11.3588 14.9863 11.4472V14.541H3.01311V11.4472C3.01311 11.3588 2.94079 11.2865 2.8524 11.2865H1.64704C1.55865 11.2865 1.48633 11.3588 1.48633 11.4472V15.4249C1.48633 15.7805 1.7736 16.0678 2.12919 16.0678H15.8703C16.2258 16.0678 16.5131 15.7805 16.5131 15.4249V11.4472C16.5131 11.3588 16.4408 11.2865 16.3524 11.2865Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.647c02219a3abdb92bfde028a63a7ef5.svg";
export { ForwardRef as ReactComponent };